module.exports = __webpack_public_path__ + "img/掇月logo.ab733c74.png";